import { Controller, useFormContext } from "react-hook-form";
import { Trash2 } from "lucide-react";

import { Button } from "components/ui/button";
import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
} from "components/ui/combobox";
import { Item, ItemActions, ItemContent } from "components/ui/item";
import { ValueEditor } from "components/NewAdvancedSearch/ValueEditor";

export function FilterCard({ index, filters = [], usedKeys = [], onRemove }) {
  const { control, setValue, watch } = useFormContext();
  const descriptor = watch(`rules.${index}.field`);

  return (
    <Item variant="muted">
      <ItemContent>
        <div className="tw:flex tw:items-center tw:justify-between tw:gap-2">
          <Controller
            control={control}
            name={`rules.${index}.field`}
            render={({ field }) => (
              <Combobox
                items={filters}
                value={field.value}
                onValueChange={item => {
                  field.onChange(item);
                  setValue(`rules.${index}.value`, null);
                }}
                itemToStringValue={item => item.key}
                itemToStringLabel={item => item.title}
                isItemEqualToValue={(item, value) => item.key === value?.key}
              >
                <ComboboxInput
                  placeholder="Select a filter"
                  className="tw:bg-white tw:dark:bg-background tw:w-52 tw:max-w-full"
                />
                <ComboboxContent>
                  <ComboboxEmpty>No items found.</ComboboxEmpty>
                  <ComboboxList>
                    {item => (
                      <ComboboxItem
                        key={item.key}
                        value={item}
                        disabled={
                          usedKeys.includes(item.key) &&
                          item.key !== descriptor?.key
                        }
                      >
                        {item.title}
                      </ComboboxItem>
                    )}
                  </ComboboxList>
                </ComboboxContent>
              </Combobox>
            )}
          />
          {descriptor && (
            <Controller
              control={control}
              name={`rules.${index}.value`}
              render={({ field }) => (
                <ValueEditor
                  descriptor={descriptor}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          )}
        </div>
      </ItemContent>
      <ItemActions>
        <Button
          type="button"
          variant="destructive"
          size="icon"
          onClick={onRemove}
        >
          <Trash2 />
        </Button>
      </ItemActions>
    </Item>
  );
}
